"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var dialog_1 = require("@angular/material/dialog");
var ConfirmationSheetComponent = /** @class */ (function () {
    function ConfirmationSheetComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this._message = "";
        this._title = "";
        if (data) {
            this.title = data.title || "??";
            this.message = data.message || "??";
        }
    }
    Object.defineProperty(ConfirmationSheetComponent.prototype, "title", {
        get: function () {
            return this._title;
        },
        set: function (value) {
            this._title = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfirmationSheetComponent.prototype, "message", {
        get: function () {
            return this._message;
        },
        set: function (message) {
            this._message = (message && message.trim()) || "";
        },
        enumerable: true,
        configurable: true
    });
    ConfirmationSheetComponent.prototype.ngOnInit = function () {
    };
    ConfirmationSheetComponent.prototype.noClick = function () {
        this.dialogRef.close(ConfirmationResult.No);
    };
    ConfirmationSheetComponent.prototype.yesClick = function () {
        this.dialogRef.close(ConfirmationResult.Yes);
    };
    return ConfirmationSheetComponent;
}());
exports.ConfirmationSheetComponent = ConfirmationSheetComponent;
var ConfirmationResult;
(function (ConfirmationResult) {
    ConfirmationResult[ConfirmationResult["Yes"] = 0] = "Yes";
    ConfirmationResult[ConfirmationResult["No"] = 1] = "No";
})(ConfirmationResult = exports.ConfirmationResult || (exports.ConfirmationResult = {}));
